export default __webpack_public_path__ + "static/barcelona_code_school_campus_-4-8069b59338910393e515f5cda8d02e20.jpg";